document.querySelectorAll('.FilterPriceRange').forEach((el) => {
    FilterPriceRange(el)
});

function FilterPriceRange(el) {
    const inputsEl = Array.from(el.querySelectorAll('.FilterPriceRange__input'));
    const cleanBtn = el.querySelectorAll('.FilterPriceRange__value-clean');
    const infoEl = el.querySelector('.FilterPriceRange__info');
    const defaultInfo = infoEl.innerHTML;
    const unit = el.dataset.unit;
    const unitPrice = el.dataset.unitPrice || '₽';

    inputsEl.forEach((input, i) => {
        input.addEventListener('input', (e) => {
            formatInput(input);
            calcInfo();
        }, {passive: true});
        input.addEventListener('change', (e) => {
            formatInput(input);
            calcInfo();
        }, {passive: true});
        formatInput(input);
        calcInfo();
    });

    cleanBtn.forEach((btn, i) => {
        btn.addEventListener('click', (e) => {
            inputsEl[i].value = '';
            calcInfo();
        });
    });

    function formatInput(input) {
        const range = [input.selectionStart, input.selectionEnd];
        const len = input.value.length;
        const val = getValue(input.value);
        if(unit) {
            input.value = val || '';
        }
        else {
            input.value = !isNaN(val) && val ? val.toLocaleString() : '';
        }
        const addLen = input.value.length-len;
        input.setSelectionRange(range[0]+addLen, range[1]+addLen);

        input.classList.toggle('small', len > 7);
    }

    function calcInfo() {
        const names = ['от', 'до'];
        const infoStr = inputsEl.reduce((str, input, i) => {
            if(input.value) {
                return `${str} ${names[i]} ${formatVal(getValue(input.value))}`
            }
            return str;
        }, '');
        infoEl.innerText = infoStr || defaultInfo;
    }

    function formatVal(num) {
        if(unit) return `${num} ${unit}`;
        else return formatPrice(num)+` ${unitPrice}`;
    }

    function formatPrice(num) {
        if (num > 1000000000) {
            return roundFloat(num / 1000000000) + ' млрд'
        } else if (num > 1000000) {
            return roundFloat(num / 1000000) + ' млн'
        } else if (num > 1000) {
            return roundFloat(num / 1000) + ' тыс'
        }
        return Math.round(num);
    }

    function roundFloat(n, count = 2) {
        return Math.round(n * (10 * count)) / (10 * count)
    }

    function getValue(n) {
        return Math.round(parseFloat(n.replaceAll(' ', '').replaceAll(' ', '')) || 0);
    }
}

function saveCursorPosition(cb, offsetForce, endOffset) {
    const selected = window.getSelection();
    const offset = selected.rangeCount && selected.getRangeAt(0).cloneRange().startOffset;

    cb();

    if((offset || offsetForce) !== undefined) {
        const range = document.createRange();
        const node = selected.anchorNode.childNodes[0];
        range.setStart(node, offsetForce || offset);
        if(endOffset) {
            range.setEnd(node, endOffset);
        }
        else {
            range.collapse(true);
        }
        selected.removeAllRanges();
        selected.addRange(range);
    }
}
